import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledWrapper = styled.main`
  display: flex;
  flex-direction: column;
  padding-top: ${rem('72px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex: 1 1 auto;
    padding: ${rem('44px')} ${rem('24px')} 0 ${rem('24px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding-right: ${rem('64px')};
    padding-left: ${rem('64px')};
  }
`;
